// extracted by mini-css-extract-plugin
export default {"layout":"ProductOnePage_layout__PXnbb","scrollContainer":"ProductOnePage_scrollContainer__t9ZYc","flexContainer":"ProductOnePage_flexContainer__yzLle"};